import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-left-toolbar',
    templateUrl: './left-toolbar.component.html',
    styleUrls: ['./left-toolbar.component.css']
})
export class LeftToolbarComponent implements OnInit {
  @Input() hasMenu: boolean = false;
  @Input() hasSearch: boolean = false;
  @Input() hasRefresh: boolean = true;

  @Input() hideMenuButton: boolean = true;
  @Input() hideSearchButton: boolean = false;
  @Input() hideRefreshButton: boolean = false;

  @Output() menuClicked = new EventEmitter<void>();
  @Output() searchClicked = new EventEmitter<void>();
  @Output() refreshClicked = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  onToggleMenu() {
    this.menuClicked.emit();
  }

  onToggleSearch() {
      this.searchClicked.emit();
  }

  onRefresh() {
      this.refreshClicked.emit();
  }
}
